export default __webpack_public_path__ + "static/media/phone.1e1ff238.svg";